import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-54ddb88a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
    key: 0,
    class: "message is-small is-link"
};
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("div", { class: "message-header" }, [
    /*#__PURE__*/ _createElementVNode("p", null, "Change Status")
], -1));
const _hoisted_3 = { class: "message-body" };
const _hoisted_4 = { class: "buttonsWrapper" };
const _hoisted_5 = ["onClick"];
import { requestStatusLabels } from "@/features/applications/model";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ApplicationActionButtonCollection',
    props: {
        status: {},
        inProgressAction: {},
        statusTransitions: {}
    },
    emits: ["changeRequestStatus"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        return (_ctx, _cache) => {
            var _a;
            return ((_a = _ctx.statusTransitions[_ctx.status]) === null || _a === void 0 ? void 0 : _a.length)
                ? (_openBlock(), _createElementBlock("article", _hoisted_1, [
                    _hoisted_2,
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusTransitions[_ctx.status], (availableStatus) => {
                                return (_openBlock(), _createElementBlock("div", {
                                    key: availableStatus,
                                    class: "control is-small"
                                }, [
                                    _createElementVNode("button", {
                                        type: "submit",
                                        class: _normalizeClass(["formButton button is-info is-small", { 'is-loading': _ctx.inProgressAction == `changeRequestStatus.${availableStatus}` }]),
                                        onClick: ($event) => (emit('changeRequestStatus', availableStatus))
                                    }, "Mark As " + _toDisplayString(_unref(requestStatusLabels)[availableStatus]), 11, _hoisted_5)
                                ]));
                            }), 128))
                        ])
                    ])
                ]))
                : _createCommentVNode("", true);
        };
    }
});
